import state from './state'
import * as mutations from './mutations'

const locales = {
    namespaced: true,
    state,
    mutations,
}

export default locales